const buildType = {
  PRODUCTION: "PRODUCTION",
  DEVELOPMENT: "DEVELOPMENT",
  MOCK: "MOCK",
};

export default buildType;
